var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"do-it-yorself"},[_c('v-e24-nav-bar'),_vm._v(" "),_c('headerInterior'),_vm._v(" "),_c('contentTwoColumns'),_vm._v(" "),_c('greenBar'),_vm._v(" "),_c('bigImage'),_vm._v(" "),_c('threeColumns'),_vm._v(" "),_c('v-e24-footer',{attrs:{"build":_vm.build}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b17e274","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Doit.vue
// module id = null
// module chunks = 